import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Input, Icon, DatePicker, Card, Row, Col, Select, Button, message } from 'antd'
import { getDispatches } from '../../modules/dispatch'
import { setQuery, setRange, setStatus, setType } from '../../modules/search'
import { request } from '../../utils/http'
import custom from '../../config/custom'
import _ from 'lodash'
import moment from 'moment'

const { RangePicker } = DatePicker
const Option = Select.Option

class SearchBox extends Component {

  constructor(props) {
    super(props)

    this.state = {
      fetchOnClear: false,
      exporting: false,
      dispatchTypes: [],
      downloading: false,
    }
  }

  componentWillMount() {
    this.mounted = true

    request(`${custom.baseUrl}/dispatchtype`)
      .then(response => {
        this.setState({
          dispatchTypes: response.data
        })
      })
      .catch(() => {
        //
      })
  }

  componentWillUnmount() {
    this.mounted = false
  }

  handleDownloadReport = () => {
    this.setState({
      downloading: !this.state.downloading,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.query !== nextProps.query) {
      if (!nextProps.query && this.state.fetchOnClear) {
        this.setState({ fetchOnClear: false }, () => {
          this.search()
        })
      } else if (nextProps.query.match(/(TMS-|([A-Z]{3,}:)).+/i)) {
        this.setState({ fetchOnClear: true }, () => {
          this.search()
        })
      }
    }

    if (this.props.range !== nextProps.range) {
      this.search()
    }
  }

  search = _.debounce(() => {
    this.props.getDispatches(this.props.page,this.props.pageSize)
  }, 500)

  async exportToExcel() {
    this.handleDownloadReport();
    const [start, end] = this.props.range;
    const url = `${custom.baseUrl}/dispatch/export-to-excel?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`;
    await request(
      url,
      {
        headers: {
          'Content-Type': 'blob'
        },
        responseType: 'arraybuffer'
      }
    ).then((response) => {
      message.success('Reporte descargado con éxito');
      const fileName = `G_TMS-${moment().format('llll')}.xlsx`;
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    })
    .catch(() => {
      message.error('Ha ocurrido un error al descargar el reporte, intente nuevamente');
    })
    .finally(() => {
      this.handleDownloadReport();
    })
  }

  render() {
    return (
      <Fragment>
        <Card>
          <Row gutter={10} style={{ marginBottom: 10 }}>
            <Col span={8}>
                <Select
                  value={this.props.status}
                  mode={'multiple'}
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Estatus"
                  onChange={value => { this.props.setStatus(value) }}
                >
                  <Option value={'createdAt'}>Solicitud creada</Option>
                  <Option value={'receivedAt'}>Solicitud recibida</Option>
                  <Option value={'approvedAt'}>Solicitud aprobada</Option>
                  <Option value={'startedAt'}>Tránsito iniciado</Option>
                  <Option value={'finishedAt'}>Tránsito finalizado</Option>
                  <Option value={'closedAt'}>Tránsito cerrado</Option>
                  <Option value={'canceledAt'}>Tránsito cancelado</Option>
                  <Option value={'billedAt'}>Tránsito Facturado</Option>
                  <Option value={'sapAt'}>Tránsito pendiente de facturar</Option>
                </Select>
            </Col>
            <Col span={8}>
              <Select
                value={this.props.type}
                mode={'multiple'}
                allowClear
                style={{ width: '100%' }}
                placeholder="Movimiento"
                onChange={value => { this.props.setType(value) }}
              >
                {this.state.dispatchTypes.map(type => {
                  return <Option key={type.id} value={type.id}>{type.name}</Option>
                })}
              </Select>
            </Col>
            <Col span={8}>
              <RangePicker
                style={{ width: '100%' }}
                allowClear={false}
                value={this.props.range}
                onChange={val => { this.props.setRange(val) }}
              />
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={16}>
              <Input
                value={this.props.query}
                prefix={<Icon type={'search'} />}
                placeholder={'TMS-'}
                onChange={e => { this.props.setQuery(e.target.value) }}
              />
            </Col>
            <Col span={8}>
              <Button
                onClick={() => this.exportToExcel()}
                loading={this.state.exporting}
                disabled={this.props.total < 1 || this.state.downloading}
                type={'primary'}
                style={{ width: '100%' }}
              >
                <Icon type={'file-excel'} />&nbsp;{ this.state.downloading ? 'Exportando reporte...' : 'Exportar a Excel' }
              </Button>
            </Col>
          </Row>
        </Card>
      </Fragment>
    )
  }

}

const mapStateToProps = state => ({
  query: state.search.query,
  range: state.search.range,
  type: state.search.type,
  status: state.search.status,
})


const mapDispatchToProps = dispatch => bindActionCreators({
  setQuery,
  setRange,
  setType,
  setStatus,
  getDispatches
}, dispatch)

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SearchBox)
)



// WEBPACK FOOTER //
// ./src/containers/SearchBox/index.js